document.addEventListener('DOMContentLoaded', function () {
  /* ------------------------------------------------------------------
     Formulario de contacto: si la página recarga después de un envío
     exitoso (form.posted_successfully?), además del mensaje en pantalla
     se dispara un toast y se hace scroll suave hacia el mensaje.
     ------------------------------------------------------------------ */
  var contactSuccessMessage = document.querySelector('[data-contact-success-message]');
  if (contactSuccessMessage) {
    contactSuccessMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (typeof showToast === 'function') {
      showToast('¡Mensaje enviado! Te contactaremos pronto. 📩', 'success');
    }
  }

  /* ------------------------------------------------------------------
     Buscadores: muestra el botón de limpiar (cruz) solo cuando el
     input tiene texto, y lo vacía al hacer clic.
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-search-form]').forEach(function (form) {
    var input = form.querySelector('[data-search-input]');
    var clearBtn = form.querySelector('[data-search-clear]');
    if (!input || !clearBtn) return;

    function syncClearVisibility() {
      form.classList.toggle('has-value', input.value.length > 0);
    }

    syncClearVisibility();
    input.addEventListener('input', syncClearVisibility);

    clearBtn.addEventListener('click', function () {
      input.value = '';
      syncClearVisibility();
      input.focus();
    });
  });

  /* ------------------------------------------------------------------
     Header fijo: reserva el espacio exacto que ocupa (ticker + nav)
     para que el contenido de la página nunca quede tapado, incluso si
     el texto del ticker pasa a dos líneas en pantallas angostas.
     ------------------------------------------------------------------ */
  var headerGroup = document.querySelector('[data-header-group]');

  function syncHeaderOffset() {
    if (!headerGroup) return;
    document.body.style.paddingTop = headerGroup.offsetHeight + 'px';
  }

  if (headerGroup) {
    syncHeaderOffset();
    window.addEventListener('resize', syncHeaderOffset);
    window.addEventListener('load', syncHeaderOffset);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncHeaderOffset);
    }
    if (window.ResizeObserver) {
      new ResizeObserver(syncHeaderOffset).observe(headerGroup);
    }
  }

  /* ------------------------------------------------------------------
     Galería de producto: clic en una miniatura reemplaza la imagen
     principal. Delegado en document para funcionar en cualquier
     sección (Producto Destacado, página de producto, etc.) sin
     importar cuántas galerías haya en la página.
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumbnail-src]');
    if (!thumb) {
      return;
    }
    e.preventDefault();

    var targetId = thumb.getAttribute('data-target-main');
    var newSrc = thumb.getAttribute('data-thumbnail-src');
    var mainImage = targetId ? document.getElementById(targetId) : null;
    if (!mainImage || !newSrc) {
      return;
    }

    mainImage.src = newSrc;
    mainImage.srcset = newSrc;

    // Solo se activa dentro del mismo grupo (mismas miniaturas apuntando
    // a la misma imagen principal), así conviven varias galerías en una
    // misma página sin pisarse entre sí.
    document.querySelectorAll('[data-thumbnail-src][data-target-main="' + targetId + '"]').forEach(function (el) {
      el.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  var cartDrawer = document.querySelector('.cart-drawer');
  var cartDrawerOverlay = document.querySelector('[data-cart-drawer-overlay]');
  var cartDrawerToggles = document.querySelectorAll('[data-cart-drawer-toggle]');
  var cartDrawerClose = document.querySelector('[data-cart-drawer-close]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('cart-drawer--open');
    if (cartDrawerOverlay) {
      cartDrawerOverlay.classList.add('is-open');
    }
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawerToggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    });
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('cart-drawer--open');
    if (cartDrawerOverlay) {
      cartDrawerOverlay.classList.remove('is-open');
    }
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawerToggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
    document.body.style.overflow = '';
  }

  // Delegación de eventos: funciona aunque el clic caiga sobre el SVG/path interno del ícono
  document.addEventListener('click', function (e) {
    var cartToggle = e.target.closest('[data-cart-drawer-toggle]');
    if (!cartToggle) {
      return;
    }
    e.preventDefault();
    if (cartDrawer && cartDrawer.classList.contains('cart-drawer--open')) {
      closeCartDrawer();
    } else {
      openCartDrawer();
    }
  });

  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', closeCartDrawer);
  }

  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('cart-drawer--open')) {
      closeCartDrawer();
    }
  });

  /* ------------------------------------------------------------------
     Toasts
     ------------------------------------------------------------------ */
  var toastContainer = document.getElementById('toast-container');

  function showToast(message, type) {
    if (!toastContainer) return;
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    toastContainer.appendChild(toast);
    setTimeout(function () {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 3000);
  }

  /* ------------------------------------------------------------------
     Carrito vía AJAX
     ------------------------------------------------------------------ */
  var shippingEl = document.querySelector('[data-cart-drawer-shipping]');
  var itemsEl = document.querySelector('[data-cart-drawer-items]');
  var footerEl = document.querySelector('[data-cart-drawer-footer]');
  var cartForm = document.querySelector('.cart-drawer__form');
  var drawerClearBtn = document.querySelector('.cart-drawer [data-cart-clear]');

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return '$' + Math.round(amount);
    }
  }

  function renderShippingHTML(itemCount) {
    if (itemCount === 0) {
      return '<p class="cart-drawer__shipping-text">Lleva 2 gorros para <strong>ENVÍO GRATIS</strong></p>' +
        '<div class="cart-drawer__progress"><div class="cart-drawer__progress-bar" style="width: 0%;"></div></div>';
    }
    if (itemCount === 1) {
      return '<p class="cart-drawer__shipping-text cart-drawer__shipping-text--offer">🔥 ¡Te falta 1 gorro para ENVÍO GRATIS! 🔥</p>' +
        '<div class="cart-drawer__progress"><div class="cart-drawer__progress-bar cart-drawer__progress-bar--offer" style="width: 50%;"></div></div>';
    }
    return '<p class="cart-drawer__shipping-text cart-drawer__shipping-text--offer">✅ ¡Tienes ENVÍO GRATIS!</p>' +
      '<div class="cart-drawer__progress"><div class="cart-drawer__progress-bar cart-drawer__progress-bar--offer" style="width: 100%;"></div></div>';
  }

  function renderItemsHTML(items) {
    if (!items || items.length === 0) {
      return '<p class="cart-drawer__empty">Tu carrito está vacío.</p>';
    }
    return items.map(function (item) {
      var imageUrl = item.image
        ? item.image + (item.image.indexOf('?') > -1 ? '&width=160' : '?width=160')
        : '';
      var image = imageUrl
        ? '<img src="' + imageUrl + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="80" height="80">'
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      return (
        '<div class="cart-drawer__item">' +
          '<a href="' + item.url + '" class="cart-drawer__item-media">' + image + '</a>' +
          '<div class="cart-drawer__item-info">' +
            '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<p class="cart-drawer__item-price">' + formatMoney(item.final_price) + '</p>' +
            '<div class="cart-drawer__qty">' +
              '<button type="submit" name="updates[' + item.key + ']" value="' + (item.quantity - 1) + '" class="cart-drawer__qty-btn" aria-label="Restar cantidad">&minus;</button>' +
              '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
              '<button type="submit" name="updates[' + item.key + ']" value="' + (item.quantity + 1) + '" class="cart-drawer__qty-btn" aria-label="Sumar cantidad">&plus;</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cart-drawer__remove-btn" data-cart-remove="' + item.key + '" title="Eliminar producto" aria-label="Eliminar producto">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<polyline points="3 6 5 6 21 6"></polyline>' +
              '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>' +
            '</svg>' +
          '</button>' +
        '</div>'
      );
    }).join('');
  }

  function renderFooterHTML(cart) {
    if (cart.item_count === 0) {
      return '';
    }
    return (
      '<div class="cart-drawer__subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<button type="submit" name="checkout" class="cart-drawer__checkout">FINALIZAR COMPRA</button>'
    );
  }

  // Recuerda el último conteo conocido del carrito para saber si estaba
  // vacío justo antes de una acción de "agregar" (así solo se abre el
  // drawer automáticamente cuando el carrito pasa de 0 a 1 producto).
  var lastKnownCartCount = 0;

  function updateCartCount(itemCount) {
    lastKnownCartCount = itemCount;
    document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
      badge.textContent = itemCount;
      if (itemCount > 0) {
        badge.classList.remove('is-hidden');
      } else {
        badge.classList.add('is-hidden');
      }
    });
  }

  function renderCartDrawer(cart) {
    if (shippingEl) {
      shippingEl.innerHTML = renderShippingHTML(cart.item_count);
    }
    if (itemsEl) {
      // Se limpia explícitamente antes de insertar para evitar cualquier duplicado visual
      itemsEl.innerHTML = '';
      itemsEl.innerHTML = renderItemsHTML(cart.items);
    }
    if (footerEl) {
      footerEl.innerHTML = renderFooterHTML(cart);
      footerEl.hidden = cart.item_count === 0;
    }
    if (drawerClearBtn) {
      drawerClearBtn.hidden = cart.item_count === 0;
    }
    updateCartCount(cart.item_count);
    syncProductCards(cart);
  }

  /* ------------------------------------------------------------------
     Selector de cantidad en las tarjetas de producto
     ------------------------------------------------------------------ */
  function getCartQuantityMap(cart) {
    var map = {};
    (cart.items || []).forEach(function (item) {
      map[item.variant_id] = (map[item.variant_id] || 0) + item.quantity;
    });
    return map;
  }

  function syncProductCards(cart) {
    var map = getCartQuantityMap(cart);
    document.querySelectorAll('[data-product-card]').forEach(function (card) {
      var variantId = card.getAttribute('data-variant-id');
      var qty = map[variantId] || 0;
      var addBtn = card.querySelector('[data-card-add]');
      var qtySelector = card.querySelector('[data-card-qty-selector]');
      var countEl = qtySelector ? qtySelector.querySelector('.card-qty-count') : null;

      if (qty > 0) {
        if (addBtn) addBtn.hidden = true;
        if (qtySelector) qtySelector.hidden = false;
        if (countEl) countEl.textContent = qty;
      } else {
        if (addBtn) addBtn.hidden = false;
        if (qtySelector) qtySelector.hidden = true;
      }
    });
  }

  // Sincroniza las tarjetas al cargar la página con el estado real del carrito
  fetch('/cart.js')
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      syncProductCards(cart);
      updateCartCount(cart.item_count);
    })
    .catch(function (err) {
      console.error(err);
    });

  // Botones "+" / "-" del selector de cantidad en las tarjetas.
  // Se bloquea por variante mientras hay una petición en curso, para que un
  // doble clic (o el mismo producto repetido en dos secciones de la home)
  // nunca dispare dos cálculos superpuestos.
  var cardQtyBusy = {};

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-product-card] .card-qty-btn');
    if (!qtyBtn) {
      return;
    }
    e.preventDefault();

    var card = qtyBtn.closest('[data-product-card]');
    var variantId = card.getAttribute('data-variant-id');

    if (cardQtyBusy[variantId]) {
      return;
    }
    cardQtyBusy[variantId] = true;

    // Bloquea visualmente ambos botones (y los pone en gris vía CSS
    // ":disabled") hasta que la petición realmente termine.
    var cardMinusBtn = card.querySelector('.card-qty-btn--minus');
    var cardPlusBtn = card.querySelector('.card-qty-btn--plus');
    var cardQtySelectorEl = card.querySelector('[data-card-qty-selector]');
    if (cardMinusBtn) cardMinusBtn.disabled = true;
    if (cardPlusBtn) cardPlusBtn.disabled = true;
    if (cardQtySelectorEl) cardQtySelectorEl.classList.add('is-busy');

    var action = qtyBtn.getAttribute('data-action');
    var wasEmpty = lastKnownCartCount === 0;

    // Se consulta el carrito real justo antes de calcular la nueva cantidad,
    // en vez de confiar en el número mostrado en pantalla: así el cálculo
    // nunca queda desincronizado si el producto aparece en más de una
    // tarjeta o si el carrito cambió por otra vía mientras tanto.
    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        // Puede haber más de una línea para la misma variante si quedó
        // algún duplicado de antes de la corrección del bug de duplicados
        // (el drawer sí funciona bien porque opera por "key" de línea
        // exacta; el selector de la tarjeta opera por variante, así que
        // si hay 2 líneas duplicadas, sumarlas y editar solo una hacía que
        // "-" pareciera no restar y "+" pareciera duplicar). Para evitarlo,
        // se consolidan todas las líneas de esa variante en una sola.
        var matchingItems = cart.items.filter(function (item) {
          return String(item.variant_id) === String(variantId);
        });
        var currentQty = matchingItems.reduce(function (sum, item) {
          return sum + item.quantity;
        }, 0);

        var newQty = action === 'plus' ? currentQty + 1 : currentQty - 1;
        if (newQty < 0) {
          newQty = 0;
        }

        var updates = {};
        if (matchingItems.length > 0) {
          updates[matchingItems[0].key] = newQty;
          for (var i = 1; i < matchingItems.length; i++) {
            updates[matchingItems[i].key] = 0;
          }
        } else {
          updates[variantId] = newQty;
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (updatedCart) {
            renderCartDrawer(updatedCart);
            if (action === 'plus') {
              showToast('¡Producto agregado al carrito! 🛒', 'add');
              if (wasEmpty) {
                openCartDrawer();
              }
            } else if (newQty === 0) {
              showToast('Producto eliminado del carrito 🗑️', 'remove');
            }
          });
      })
      .catch(function (err) {
        console.error(err);
      })
      .then(function () {
        cardQtyBusy[variantId] = false;
        // Los botones se reactivan siempre al terminar; si el producto
        // sigue en el carrito, syncProductCards() (llamado dentro de
        // renderCartDrawer) ya dejó el selector visible con el conteo
        // correcto, solo falta quitarles el estado "ocupado".
        if (cardMinusBtn) cardMinusBtn.disabled = false;
        if (cardPlusBtn) cardPlusBtn.disabled = false;
        if (cardQtySelectorEl) cardQtySelectorEl.classList.remove('is-busy');
      });
  });

  function refreshCartDrawer() {
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        renderCartDrawer(cart);
        return cart;
      });
  }

  // Interceptar todos los formularios de "Agregar al carrito"
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    // Evita registrar el listener dos veces sobre el mismo formulario
    // (causa típica de que un producto se "duplique" al agregarlo: se
    // disparan dos peticiones /cart/add.js en paralelo).
    if (form.dataset.ajaxBound === 'true') {
      return;
    }
    form.dataset.ajaxBound = 'true';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitter = e.submitter;
      var rawFormData = new FormData(form);
      var wasEmpty = lastKnownCartCount === 0;

      // Deshabilita todos los botones de este formulario (Agregar/Comprar)
      // mientras la petición está en curso, para que no se pueda hacer
      // doble clic antes de que el producto realmente quede agregado.
      var formButtons = form.querySelectorAll('button[type="submit"]');
      formButtons.forEach(function (btn) {
        btn.disabled = true;
      });

      // Se reconstruye el FormData enviando ÚNICAMENTE "id" y "quantity".
      // Se descarta cualquier properties[...], timestamp u otro campo
      // dinámico que pudiera hacer que Shopify trate cada click como una
      // línea distinta en vez de agrupar la misma variante.
      var formData = new FormData();
      formData.append('id', rawFormData.get('id'));
      formData.append('quantity', rawFormData.get('quantity') || '1');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.status) {
            console.error(data.description || data.message || 'No se pudo agregar el producto.');
            return;
          }
          if (submitter && submitter.name === 'checkout') {
            window.location.href = '/checkout';
            return;
          }
          showToast('¡Producto agregado al carrito! 🛒', 'add');
          refreshCartDrawer().then(function () {
            if (wasEmpty) {
              openCartDrawer();
            }
          });
        })
        .catch(function (err) {
          console.error(err);
        })
        .then(function () {
          formButtons.forEach(function (btn) {
            btn.disabled = false;
          });
        });
    });
  });

  // Interceptar el formulario del carrito (cantidades y checkout desde el drawer)
  if (cartForm && cartForm.dataset.ajaxBound !== 'true') {
    cartForm.dataset.ajaxBound = 'true';
    cartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitter = e.submitter;
      if (!submitter) {
        return;
      }

      if (submitter.name === 'checkout') {
        window.location.href = '/checkout';
        return;
      }

      var match = submitter.name.match(/^updates\[(.+)\]$/);
      if (!match) {
        return;
      }

      var key = match[1];
      var quantity = parseInt(submitter.value, 10);
      if (isNaN(quantity) || quantity < 0) {
        quantity = 0;
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          renderCartDrawer(cart);
        })
        .catch(function (err) {
          console.error(err);
        });
    });
  }

  function updateCartView(cart) {
    // En el drawer podemos re-renderizar in-place; en la página completa
    // /cart (sections/main-cart.liquid) es más simple y confiable recargar
    // para que Liquid dibuje la lista actualizada del lado del servidor.
    if (itemsEl) {
      renderCartDrawer(cart);
    } else {
      window.location.reload();
    }
  }

  // Eliminar una línea individual del carrito (botón de basurero)
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) {
      return;
    }
    e.preventDefault();
    var key = removeBtn.getAttribute('data-cart-remove');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        showToast('Producto eliminado del carrito 🗑️', 'remove');
        updateCartView(cart);
      })
      .catch(function (err) {
        console.error(err);
      });
  });

  // Vaciar el carrito completo
  document.addEventListener('click', function (e) {
    var clearBtn = e.target.closest('[data-cart-clear]');
    if (!clearBtn) {
      return;
    }
    e.preventDefault();

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartView(cart);
      })
      .catch(function (err) {
        console.error(err);
      });
  });

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var searchToggle = document.querySelector('[data-search-toggle]');
  var navDrawer = document.querySelector('[data-nav-drawer]');
  var navDrawerOverlay = document.querySelector('[data-nav-drawer-overlay]');
  var navDrawerClose = document.querySelector('[data-nav-drawer-close]');
  var searchPanel = document.querySelector('[data-search-panel]');

  function openDrawer() {
    navDrawer.classList.add('is-open');
    navDrawerOverlay.classList.add('is-open');
    navDrawer.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    navDrawer.classList.remove('is-open');
    navDrawerOverlay.classList.remove('is-open');
    navDrawer.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function toggleSearchPanel() {
    var isHidden = searchPanel.hasAttribute('hidden');
    if (isHidden) {
      searchPanel.removeAttribute('hidden');
      searchToggle.setAttribute('aria-expanded', 'true');
      var input = searchPanel.querySelector('input[type="search"]');
      if (input) {
        input.focus();
      }
    } else {
      searchPanel.setAttribute('hidden', '');
      searchToggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (menuToggle && navDrawer && navDrawerOverlay) {
    menuToggle.addEventListener('click', openDrawer);
  }

  if (navDrawerClose) {
    navDrawerClose.addEventListener('click', closeDrawer);
  }

  if (navDrawerOverlay) {
    navDrawerOverlay.addEventListener('click', closeDrawer);
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', toggleSearchPanel);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (navDrawer && navDrawer.classList.contains('is-open')) {
        closeDrawer();
      }
      if (searchPanel && !searchPanel.hasAttribute('hidden')) {
        searchPanel.setAttribute('hidden', '');
        if (searchToggle) {
          searchToggle.setAttribute('aria-expanded', 'false');
        }
      }
    }
  });
});

/* ------------------------------------------------------------------
   Efecto typewriter en el título del Hero
   ------------------------------------------------------------------ */
document.addEventListener('DOMContentLoaded', function () {
  var textElement = document.querySelector('.typewriter-text');
  if (!textElement) return;

  var phrasesAttr = textElement.getAttribute('data-phrases');
  if (!phrasesAttr) return;

  var phrases = phrasesAttr.split(',').map(function (phrase) {
    return phrase.trim();
  }).filter(function (phrase) {
    return phrase.length > 0;
  });
  if (phrases.length === 0) return;

  var currentPhraseIndex = 0;
  var currentCharIndex = 0;
  var isDeleting = false;

  // Velocidades (en milisegundos)
  var typingSpeed = 100;
  var deletingSpeed = 50;
  var delayBetweenPhrases = 2000;

  function type() {
    var currentPhrase = phrases[currentPhraseIndex];

    if (isDeleting) {
      textElement.textContent = currentPhrase.substring(0, currentCharIndex - 1);
      currentCharIndex--;
    } else {
      textElement.textContent = currentPhrase.substring(0, currentCharIndex + 1);
      currentCharIndex++;
    }

    var timeoutSpeed = isDeleting ? deletingSpeed : typingSpeed;

    if (!isDeleting && currentCharIndex === currentPhrase.length) {
      timeoutSpeed = delayBetweenPhrases;
      isDeleting = true;
    } else if (isDeleting && currentCharIndex === 0) {
      isDeleting = false;
      currentPhraseIndex = (currentPhraseIndex + 1) % phrases.length;
      timeoutSpeed = 500; // Pequeña pausa antes de empezar la nueva frase
    }

    setTimeout(type, timeoutSpeed);
  }

  // El texto ya arranca escrito con la primera frase (renderizado por
  // Liquid) para que el <h1> nunca esté vacío sin JS; acá se borra esa
  // primera frase y arranca el ciclo normal.
  currentCharIndex = textElement.textContent.length;
  isDeleting = true;

  // Si por algún motivo el texto inicial no calza con phrases[0]
  // (contenido editado a mano), se reinicia desde cero.
  if (textElement.textContent !== phrases[0].substring(0, currentCharIndex)) {
    currentCharIndex = 0;
    isDeleting = false;
  }

  setTimeout(type, 1500);
});

/* ------------------------------------------------------------------
   Botón "Volver" del header (vuelve a la vista anterior del historial)
   ------------------------------------------------------------------ */
document.addEventListener('click', function (e) {
  var backBtn = e.target.closest('[data-nav-back]');
  if (!backBtn) {
    return;
  }
  e.preventDefault();
  if (window.history.length > 1) {
    window.history.back();
  } else {
    window.location.href = backBtn.getAttribute('href') || '/';
  }
});
